import { render, staticRenderFns } from "./storeBranches.vue?vue&type=template&id=4e9978a5&scoped=true"
import script from "./storeBranches.vue?vue&type=script&lang=js"
export * from "./storeBranches.vue?vue&type=script&lang=js"
import style0 from "./storeBranches.vue?vue&type=style&index=0&id=4e9978a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9978a5",
  null
  
)

export default component.exports